import { render, staticRenderFns } from "./cryotherapy.vue?vue&type=template&id=5169f7a2&scoped=true&"
import script from "./cryotherapy.vue?vue&type=script&lang=js&"
export * from "./cryotherapy.vue?vue&type=script&lang=js&"
import style0 from "./cryotherapy.vue?vue&type=style&index=0&id=5169f7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169f7a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5169f7a2')) {
      api.createRecord('5169f7a2', component.options)
    } else {
      api.reload('5169f7a2', component.options)
    }
    module.hot.accept("./cryotherapy.vue?vue&type=template&id=5169f7a2&scoped=true&", function () {
      api.rerender('5169f7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/cryotherapy.vue"
export default component.exports